import {
    empty,
    copyObj
} from './tools.js'

/**
 * 构造树型结构数据
 * @param {*} data 数据源
 * @param {*} id id字段 默认 'id'
 * @param {*} parentId 父节点字段 默认 'parentId'
 * @param {*} children 孩子节点字段 默认 'children'
 */
export function handleTree(data, id, parentId, children) {
    let config = {
        id: id || 'id',
        parentId: parentId || 'parentId',
        childrenList: children || 'children'
    };

    let childrenListMap = {};
    let nodeIds = {};
    let tree = [];

    for (let d of data) {
        let parentId = d[config.parentId];
        if (childrenListMap[parentId] == null) {
            childrenListMap[parentId] = [];
        }
        nodeIds[d[config.id]] = d;
        childrenListMap[parentId].push(d);
    }

    for (let d of data) {
        let parentId = d[config.parentId];
        if (nodeIds[parentId] == null) {
            tree.push(d);
        }
    }

    for (let t of tree) {
        adaptToChildrenList(t);
    }

    function adaptToChildrenList(o) {
        if (childrenListMap[o[config.id]] !== null) {
            o[config.childrenList] = childrenListMap[o[config.id]];
        }
        if (o[config.childrenList]) {
            for (let c of o[config.childrenList]) {
                adaptToChildrenList(c);
            }
        }
    }
    return tree;
}

/**
 * 处理树型节点的disabled
 * @param tree
 * @param id
 * @param children
 * @param disabledIdArr 需要处理节点的id数组
 * @returns {*}
 */
export function handleTreeFilterDisabled(tree, id, children, disabledIdArr) {
    let config = {
        id: id || 'id',
        childrenList: children || 'children'
    };
    if (empty(disabledIdArr)) return tree
    let newTree = copyObj(tree)

    for (let i in newTree) {
        adaptToChildrenList(newTree[i], false)
    }

    function adaptToChildrenList(o, flag) {
        if (flag || disabledIdArr.indexOf(o[config.id]) !== -1) {
            o.disabled = true
            flag = true
        }

        if (o[config.childrenList]) {
            for (let c of o[config.childrenList]) {
                adaptToChildrenList(c, flag);
            }
        }
    }

    return newTree
}

// 辅助函数：查找阶段在章节中的索引位置
export function findPhaseIndex(chapter, phaseId) {
    if (!chapter || !chapter.phaseVoList) return -1;
    return chapter.phaseVoList.findIndex(
        (phase) => phase.phaseId == phaseId
    );
}

// 辅助函数：获取章节的下一个阶段
export function getNextPhase(currentChapter, currentPhaseIndex) {
    if (!currentChapter || !currentChapter.phaseVoList) return null;

    // 如果当前阶段不是最后一个，返回同一章节的下一个阶段
    if (currentPhaseIndex < currentChapter.phaseVoList.length - 1) {
        return {
            chapterId: currentChapter.chapterId,
            phaseId: currentChapter.phaseVoList[currentPhaseIndex + 1].phaseId,
        };
    }
    return null; // 当前阶段已是本章最后
}

// 辅助函数：获取下一章节的第一个阶段
export function getNextChapterFirstPhase(chapters, currentChapterIndex) {
    if (currentChapterIndex < chapters.length - 1) {
        const nextChapter = chapters[currentChapterIndex + 1];
        if (nextChapter.phaseVoList && nextChapter.phaseVoList.length > 0) {
            return {
                chapterId: nextChapter.chapterId,
                phaseId: nextChapter.phaseVoList[0].phaseId,
            };
        }
    }
    return null;
}

// 主方法：判断目标阶段是否满足条件
export function isTargetInRange(
    targetChapterId,
    targetPhaseId,
    currentChapterId,
    currentPhaseId,
    chapters
) {
    // 1. 建立章节索引映射
    const chapterIndexMap = new Map();
    chapters.forEach((chapter, index) => {
        chapterIndexMap.set(chapter.chapterId, index);
    });

    const currentIdx = chapterIndexMap.get(currentChapterId);
    const targetIdx = chapterIndexMap.get(targetChapterId);

    // 无效章节处理
    if (currentIdx == undefined || targetIdx == undefined) {
        return false;
    }

    // 2. 获取当前章节对象和阶段索引
    const currentChapter = chapters[currentIdx];
    const currentPhaseIndex = findPhaseIndex(
        currentChapter,
        currentPhaseId
    );

    // 当前阶段无效
    if (currentPhaseIndex == -1) return false;

    // 3. 检查目标阶段是否为当前阶段或之前
    if (targetIdx < currentIdx) {
        return true; // 所有之前章节的阶段都符合
    }

    if (targetIdx == currentIdx) {
        // 同一章节
        const targetPhaseIndex = findPhaseIndex(
            currentChapter,
            targetPhaseId
        );
        if (targetPhaseIndex == -1) return false; // 目标阶段不存在

        // 目标阶段是当前阶段或之前阶段
        if (targetPhaseIndex <= currentPhaseIndex) {
            return true;
        }
    }

    // 4. 检查目标阶段是否为下一个阶段
    // 4.1 检查同一章节的下一个阶段
    const nextPhase = getNextPhase(currentChapter, currentPhaseIndex);
    if (
        nextPhase &&
        nextPhase.chapterId == targetChapterId &&
        nextPhase.phaseId == targetPhaseId
    ) {
        return true;
    }

    // 4.2 检查跨章节的下一个阶段（当前章节结束后）
    if (!nextPhase) {
        // 当前章节没有后续阶段
        const nextChapterPhase = getNextChapterFirstPhase(
            chapters,
            currentIdx
        );
        if (
            nextChapterPhase &&
            nextChapterPhase.chapterId == targetChapterId &&
            nextChapterPhase.phaseId == targetPhaseId
        ) {
            return true;
        }
    }

    return false;
}